// CODEX api wrapper.
const BASE = process.env.REACT_APP_BACKEND_URL;

function authHeaders() {
  const t = localStorage.getItem('access_token');
  return t ? { Authorization: `Bearer ${t}` } : {};
}

async function req(method, path, body) {
  const res = await fetch(`${BASE}/api/codex${path}`, {
    method,
    headers: { 'Content-Type': 'application/json', ...authHeaders() },
    body: body ? JSON.stringify(body) : undefined,
  });
  if (!res.ok) {
    const err = await res.json().catch(() => ({ detail: res.statusText }));
    const detail = err?.detail;
    const message = (typeof detail === 'string' ? detail : detail?.message) || `HTTP ${res.status}`;
    const e = new Error(message);
    e.status = res.status;
    e.detail = detail;
    throw e;
  }
  return res.json();
}

export const codexApi = {
  me: () => req('GET', '/me'),
  onboard: (avatar, pace) => req('POST', '/onboard', { avatar, pace }),
  dailyScroll: () => req('GET', '/daily-scroll'),
  submitAnswer: (wordId, layer, answerIndex) =>
    req('POST', `/scroll/${wordId}/answer`, { layer, answer_index: answerIndex }),
  personalCodex: () => req('GET', '/codex'),
  mentorMentees: () => req('GET', '/mentor/mentees'),
  mentorMenteeDetail: (userId) => req('GET', `/mentor/mentee/${userId}`),

  // Journal
  journalList: () => req('GET', '/journal'),
  journalCreate: (data) => req('POST', '/journal', data),
  journalUpdate: (id, data) => req('PUT', `/journal/${id}`, data),
  journalDelete: (id) => req('DELETE', `/journal/${id}`),

  // Chambers
  listChambers: () => req('GET', '/chambers'),
  getChamber: (chamberId) => req('GET', `/chambers/${chamberId}`),
  submitChamberAnswer: (chamberId, lessonId, answerIndex) =>
    req('POST', `/chambers/${chamberId}/lesson/${lessonId}/answer`, { answer_index: answerIndex }),

  // Sacred Letters
  inbox: () => req('GET', '/letters/inbox'),
  sentLetters: () => req('GET', '/letters/sent'),
  sendLetter: (data) => req('POST', '/letters', data),
  markLetterRead: (id) => req('POST', `/letters/${id}/read`),

  // Heatmap
  heatmap: (days = 30) => req('GET', `/mentor/heatmap?days=${days}`),

  // Achievements / badges
  badges: () => req('GET', '/badges'),

  // Sacred Treasury
  treasuryMe: () => req('GET', '/treasury/me'),
  treasuryCatalog: () => req('GET', '/treasury/catalog'),
  treasuryPurchase: (itemId) => req('POST', '/treasury/purchase', { item_id: itemId }),
  treasuryEquip: (itemId) => req('POST', '/treasury/equip', { item_id: itemId }),
  treasuryUnequip: (slot) => req('POST', '/treasury/unequip', { slot }),
  treasuryGift: (menteeId, amount, note) => req('POST', '/treasury/gift', { mentee_id: menteeId, amount, note }),

  // Personal Challenges (Missions)
  challengesMe: () => req('GET', '/challenges/me'),
  challengesManualProgress: (id) => req('POST', `/challenges/${id}/manual-progress`),
  challengesMentorAssign: (data) => req('POST', '/challenges/mentor/assign', data),
  challengesMentorList: (userId) => req('GET', `/challenges/mentor/mentee/${userId}`),

  // Voice Notes
  voiceInbox: () => req('GET', '/voice/inbox'),
  voiceSent: () => req('GET', '/voice/sent'),
  voiceThread: (userId) => req('GET', `/voice/thread/${userId}`),
  voiceMarkRead: (id) => req('POST', `/voice/${id}/read`),

  // Live Chat
  chatThreads: () => req('GET', '/chat/threads'),
  chatHistory: (peerId) => req('GET', `/chat/with/${peerId}`),
  chatSend: (peerId, body) => req('POST', `/chat/with/${peerId}/send`, { body }),
  chatMarkRead: (peerId) => req('POST', `/chat/with/${peerId}/read`),

  // Access management (admin/mentor)
  accessSearch: (q = '') => req('GET', `/access/search${q ? `?q=${encodeURIComponent(q)}` : ''}`),
  accessGrant: (userId, reason) => req('POST', '/access/grant', { user_id: userId, reason }),
  accessRevoke: (userId, reason) => req('POST', '/access/revoke', { user_id: userId, reason }),
  accessLog: (userId) => req('GET', `/access/log/${userId}`),

  // Audio — fetches MP3 and returns blob URL the frontend can play
  fetchWordAudio: async (wordId) => {
    const res = await fetch(`${BASE}/api/codex/word/${wordId}/audio`, {
      headers: { ...authHeaders() },
    });
    if (!res.ok) throw new Error(`Audio fetch failed (${res.status})`);
    const blob = await res.blob();
    return URL.createObjectURL(blob);
  },
};
